import {
  Image,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  Flex,
  Box,
} from "@chakra-ui/react";
import React, { useEffect } from "react";

export const CiboModal = ({ isOpen, onClose, link }) => {
  useEffect(() => {
    if (isOpen) {
      console.log(link);
    }
  }, [isOpen]);

  return (
    <Drawer placement={"bottom"} onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent
        maxH={"80vh"}
        borderTopLeftRadius="16px"
        borderTopRightRadius="16px"
        overflow="hidden"
        maxW={{ base: "100%", md: "560px" }}
        mx="auto"
        mb={{ md: 8 }}
        borderRadius={{ md: "24px" }}
      >
        <Flex
          mx={3}
          my={4}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Text mr={4} fontSize={"18px"} fontWeight={800}>
            Lobby Access
          </Text>

          <DrawerCloseButton pos={"relative"} top={0} right={0} />
        </Flex>
        <DrawerBody px={0} pt={0} pb={12}>
          <iframe src={link} width="100%" height="600px" frameBorder="0" />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
